import { SectionEditWorkoutItems } from "src/components/SectionEditWorkoutItems";
import { NoopPlugin } from "src/convenience/plugins";
import { ExerciseSearchContextProvider } from "src/workouts/ExerciseSearchContext";
import { WorkoutEditStoreProvider } from "src/workouts/WorkoutEditContext";
import { type WorkoutData } from "src/workouts/WorkoutEditStore";
import {
  EditWorkoutItemWorkoutSetProvider,
  NoopCell,
  workoutSetsWorkoutItemSetsContext,
  type WorkoutItemSetsContextValue,
} from "src/workouts/WorkoutItemSetContext";
import {
  workoutPermissionsContext,
  type WorkoutPermissionContextValue,
} from "src/workouts/WorkoutItemsPermission";
import { workoutPluginsContext } from "src/workouts/WorkoutPlugins";

const plugins = {
  workoutItemSets: NoopPlugin,
  comments: NoopPlugin,
  history: NoopPlugin,
};

const pluginsValue = { plugins };

const permissionsValue: WorkoutPermissionContextValue = {
  canEditSets: true,
  canLogSets: false,
  dragAndDropEnabled: true,
  canEditItems: true,
  canEditWorkout: true,
  workoutItemSetShown: true,
  canAddComments: false,
  canAddRootItems: true,
  canImportFromLibrary: false,
  canEditAttributes: true,
};

const readonlyPermissionsValue: WorkoutPermissionContextValue = {
  canEditSets: false,
  canLogSets: false,
  dragAndDropEnabled: false,
  canEditItems: false,
  canEditWorkout: false,
  workoutItemSetShown: true,
  canAddComments: false,
  canAddRootItems: false,
  canImportFromLibrary: false,
  canEditAttributes: false,
};

const workoutItemSetsValue: WorkoutItemSetsContextValue = {
  Provider: EditWorkoutItemWorkoutSetProvider,
  getLogCells: () => {
    return [NoopCell, NoopCell];
  },
};

interface Props {
  workout: WorkoutData;
  disabled?: boolean;
}

export function SectionEditContent(props: Props) {
  return (
    <workoutPermissionsContext.Provider
      value={props.disabled ? readonlyPermissionsValue : permissionsValue}
    >
      <workoutSetsWorkoutItemSetsContext.Provider value={workoutItemSetsValue}>
        <workoutPluginsContext.Provider value={pluginsValue}>
          <ExerciseSearchContextProvider enabled={true}>
            <WorkoutEditStoreProvider workout={props.workout}>
              <SectionEditWorkoutItems />
            </WorkoutEditStoreProvider>
          </ExerciseSearchContextProvider>
        </workoutPluginsContext.Provider>
      </workoutSetsWorkoutItemSetsContext.Provider>
    </workoutPermissionsContext.Provider>
  );
}
